import { Link, useLocation } from 'react-router-dom';

import lostTonyImg from '@/assets/images/lostTony.png';
import { Card } from '@/components/Card';
import { HomeRoute } from '@/configs/routes';

export function NotFound() {
  const location = useLocation();

  return (
    <Card className="flex flex-col items-center">
      <p className="font-display text-4xl font-semibold text-[#274483] sm:text-5xl">404</p>
      <h1 className="mt-4 font-display text-2xl font-semibold text-neutral-950">{'Page not found'}</h1>
      <p className="mt-2 text-sm text-neutral-600">{'Sorry, we couldn’t find the page you’re looking for.'}</p>

      <Link
        to={{ pathname: HomeRoute, search: location.search }}
        className="my-6 font-bold text-neutral-900 transition hover:text-neutral-700"
      >
        {'Go to the home page'}
      </Link>

      <img
        alt="Page not found"
        src={lostTonyImg}
        className="aspect-1 w-full max-w-150 mx-auto rounded-2xl object-cover outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10"
      />
    </Card>
  );
}
